import type { TTextLeaf } from '@shared/dream-components';

import type { NodeContent } from '~/interfaces/page';

function findColorInTipTapNode(node: NodeContent) {
  // @ts-expect-error
  if (node?.content?.length) {
    // @ts-expect-error
    const marks = (node.content[0] as TTextLeaf)?.marks;
    if (marks && marks.length > 0) {
      return marks[0].attrs?.color;
    }
  }
}

export { findColorInTipTapNode };
